export enum TemplateType {
	RETRO = 'simple-retrospective',
}
